import { useEffect, useState, useRef } from 'react';
import QaRender from '@/sub-luca-plugin/components/qa-render';
import DragDrawer from '@/sub-luca-plugin/components/drag-drawer';
import QaDetailDrawer from '@/sub-luca-plugin/components/qa-detail-drawer';
import SimilarSearchDrawer from '@/sub-luca-plugin/components/similar-search-drawer';
import CombinePicturesDrawer from '@/sub-luca-plugin/components/combine-pictures-drawer';
import KnowledgePointsDrawer from '@/sub-luca-plugin/components/knowledge-points-drawer';
import VideoPlayerModal from '@/sub-luca-plugin/components/video-player-modal';
import PicturePreview from '@/sub-luca-plugin/components/picture-preview';
import PictureCrop from '@/sub-luca-plugin/components/picture-crop';
import QaDetailRightDrawer from '@/sub-luca-plugin/components/qa-detail-right-drawer';
import KnowledgeSliceRightDrawer from '@/sub-luca-plugin/components/knowledge-points-right-drawer';
import EquityModal from '@/sub-luca-plugin/exports/equity';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { IQuestionAnswerProps, INoticeData } from '@/sub-luca-plugin/types';
import './index.scss';

const Qa = (_: IQuestionAnswerProps) => {
    const [open, setOpen] = useState(false);
    const qaRef = useRef<any>();

    const handleCloseDrawer = () => {
        // 关闭时，将初始化的历史参数，传递给外部的关闭回调
        eventBusExample.externalCallbacks.onCloseDrawer?.(getQaStore()?.qaConfig);
        eventBusExample.externalCallbacks.onClose?.(getQaStore()?.qaConfig);
        setOpen(false);
        // 因为弹窗关闭是有动效的，所以这里延迟清空数据，防止用户看到清空后的白屏
        setTimeout(() => qaRef.current?.reset(), 500);
    };

    useEffect(() => {
        eventBusExample.subscribe('QaDrawer', ({ type, params = {}, callbacks = {} }: INoticeData) => {
            switch (type) {
                case 'open':
                    console.log('QaDrawer_open', params);
                    setOpen(true);
                    setTimeout(() => qaRef.current.init(params), 1);
                    eventBusExample.setExternalCallbacks(callbacks);
                    break;
                default:
                    handleCloseDrawer();
                    break;
            }
        });
        return () => qaRef.current?.reset();
    }, []);

    return (
        <>
            <DragDrawer zIndex={1100} width={375} open={open} onClose={handleCloseDrawer}>
                <div className="qa-pc">
                    <SimilarSearchDrawer />
                    <QaDetailDrawer />
                    <KnowledgePointsDrawer />
                    <CombinePicturesDrawer />
                    <QaRender ref={qaRef} />
                </div>
            </DragDrawer>
            <QaDetailRightDrawer />
            <KnowledgeSliceRightDrawer />
            <PictureCrop />
            <EquityModal />
            <PicturePreview />
            <VideoPlayerModal />
        </>
    );
};

export default Qa;
